export const frontlinki = {
  items: [
    {
      link: "/oferta/szukaj.xml?dojazd=samolot&pobyt=6,14&sort=3&order=ASC&locid=ATL000001,BGL000001,CZL000001,FRL000001,DEL000001,CHL000001,SKL000001,SIL000001,ITL000001",
      linkb: "",
      nazwa: "top",
      pozycja: "1",
      tytul: "Polecane oferty"
    },
    {
      link: "/oferta/szukaj.xml?dojazd=samolot&pobyt=6,14&dni=21",
      linkb: "/last-minute/oferty.xml?dojazd=samolot&pobyt=6,14",
      nazwa: "lm",
      pozycja: "2",
      tytul: "Last Minute"
    },
    {
      link: "/oferta/szukaj.xml?dojazd=samolot&pobyt=6,14&wyz=AI",
      linkb: "/oferta/szukaj.xml?dojazd=samolot&pobyt=6,14&wyz=AI",
      nazwa: "allInclusive",
      pozycja: "3",
      tytul: "All Inclusive"
    }
  ]
};
